import { styled, Theme } from '@mui/material/styles'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { usePermissions } from 'react-admin'
import { IPermissions } from '../../types/apiTypes'
import { ContainerAlign } from './ButtonTypes'
import { FC, ReactElement } from 'react'

export const RestrictedButton: FC<RestrictedButtonProps> = ({
  access,
  align = 'left',
  children,
  className,
  fullWidth = false,
  style,
  ...props
}) => {
  const styleProps = {
    fullWidth,
  }
  const { permissions } = usePermissions() as IPermissions

  if (permissions !== undefined && access.some((i: string) => permissions?.scopes.includes(i))) {
    return (
      <Root style={style} className={clsx(classes.root, classes[`${align}`], className)} {...styleProps}>
        {children(props)}
      </Root>
    )
  }

  return null
}

interface RestrictedButtonProps {
  access: string[];
  align?: ContainerAlign;
  children: (props) => ReactElement | null;
  className?: string;
  fullWidth?: boolean;
  style?: React.CSSProperties;
}

interface StyleProps {
  fullWidth?: string;
}

const PREFIX = 'xxllncRestrictedButton'

const classes = {
  root: `${PREFIX}-root`,
  left: `${PREFIX}-left`,
  right: `${PREFIX}-right`,
  center: `${PREFIX}-left`,
}

const Root = styled('div', {
  name: PREFIX,
  overridesResolver: (props, styles) => styles.root,
})(({ theme, fullWidth }: StyleProps & { theme: Theme }) => ({
  [`&.${classes.root}`]: {
    width: fullWidth ? '100%' : 'initial',
  },
  [`&.${classes.left}`]: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginRight: theme.spacing(1),
  },
  [`&.${classes.right}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginLeft: theme.spacing(1),
  },
  [`&.${classes.center}`]: {
    display: 'flex',
    justifyContent: 'center',
  },
}))
